import { mascaraCep } from "./masks";

export async function buscarCep(cep) {
  const cepLimpo = cep.replace(/\D/g, "");

  if (!cepLimpo) {
    throw new Error("Informe o CEP.");
  }

  if (cepLimpo.length !== 8) {
    throw new Error("CEP inválido.");
  }

  const response = await fetch(
    `https://viacep.com.br/ws/${cepLimpo}/json/`
  );

  if (!response.ok) {
    throw new Error("Não foi possível consultar o CEP.");
  }

  const dados = await response.json();

  if (dados.erro) {
    throw new Error("CEP não encontrado.");
  }

  return {
    cep: mascaraCep(dados.cep || cepLimpo),
    endereco: dados.logradouro || "",
    bairro: dados.bairro || "",
    cidade: dados.localidade || "",
    estado: dados.uf || "",
  };
}